module.exports = __webpack_public_path__ + "media/images/recruit/common/og-image-531a002cfbe0fffe75499c8f9d5f918f.png";